module.exports = __webpack_public_path__ + "fonts/opensans-regular-webfont.woff";